/**
 * Croatian formatting. Dates as 31.08.2026., numbers with a comma.
 *
 * Every value that comes out of here belongs in an element carrying the
 * `.broj` class: tabular figures keep a column of amounts aligned, and make a
 * wrong digit visible instead of hiding it in a narrower glyph.
 */

/** `2026-08-31` → `31.08.2026.` The trailing dot is Croatian, not a typo. */
export function datum(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [godina, mjesec, dan] = iso.slice(0, 10).split("-");
  if (!godina || !mjesec || !dan) return "—";
  return `${dan}.${mjesec}.${godina}.`;
}

/** Short form for a badge: `31.08.` — the year is implied by "soon". */
export function datumKratko(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [, mjesec, dan] = iso.slice(0, 10).split("-");
  if (!mjesec || !dan) return "—";
  return `${dan}.${mjesec}.`;
}

/** `1850.00` → `1.850,00`. Kept as a string: money must not round on the way. */
export function iznos(vrijednost: string | number | null | undefined): string {
  if (vrijednost === null || vrijednost === undefined || vrijednost === "") {
    return "—";
  }
  const broj = typeof vrijednost === "string" ? Number(vrijednost) : vrijednost;
  if (Number.isNaN(broj)) return "—";
  return broj.toLocaleString("hr-HR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Whole numbers with a thousands separator: `1.284`. */
export function cijeliBroj(vrijednost: number): string {
  return vrijednost.toLocaleString("hr-HR");
}
